import { render, staticRenderFns } from "./EmailDialog.vue?vue&type=template&id=2b04f8be&scoped=true"
import script from "./EmailDialog.vue?vue&type=script&lang=js"
export * from "./EmailDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b04f8be",
  null
  
)

export default component.exports